import { useState, useEffect, ReactNode } from 'react';
import { Row, Col, Button, Spin } from 'antd-v4';
import Header from './Header/header';
import Footer from './Footer/footer';
import { CopyOutlined } from '@ant-design/icons';
import { message } from 'antd';

interface ErrorPageProps {
  error: Error;
  status?: number;
  showHeader?: boolean;
  showFooter?: boolean;
  showErrorDetails?: boolean;
  showReloadButton?: boolean;
  showHomeButton?: boolean;
  customActions?: ReactNode;
}

export function ErrorPage({
  error,
  status = 500,
  showHeader = true,
  showFooter = false,
  showErrorDetails = process.env.NODE_ENV === 'development',
  showReloadButton = true,
  showHomeButton = true,
  customActions,
}: ErrorPageProps): JSX.Element {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleGoHome = (): void => {
    window.location.href = '/';
  };

  const handleReload = (): void => {
    window.location.reload();
  };

  if (loading) {
    return (
      <Row className="hp-text-center hp-overflow-hidden">
        {showHeader && <Header />}
        <Col className="hp-error-content hp-py-32" span={24}>
          <Row className="hp-h-100" align="middle" justify="center">
            <Col>
              <Spin size="large" />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  return (
    <Row className="hp-text-center hp-overflow-hidden">
      {showHeader && <Header />}

      <Col className="hp-error-content hp-py-32" span={24}>
        <Row className="hp-h-100" align="middle" justify="center">
          <Col style={{ maxWidth: '600px', padding: '20px' }}>
            <h1
              className="hp-error-content-title hp-font-weight-300 hp-text-color-black-bg hp-text-color-dark-0 hp-mb-0"
              style={{ lineHeight: 0.9, justifySelf: 'center' }}
            >
              {status}
            </h1>

            <h2 className="h1 hp-mb-16">
              {error.message || "Une erreur s'est produite"}
            </h2>

            {showErrorDetails && error && (
              <div
                style={{
                  textAlign: 'left',
                  marginBottom: '20px',
                  padding: '15px',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  fontSize: '12px',
                  maxHeight: '200px',
                  overflow: 'auto',
                  position: 'relative',
                }}
              >
                <strong>Détails de l'erreur :</strong>
                <pre style={{ whiteSpace: 'pre-wrap' }}>
                  {error.stack && (
                    <>
                      {'\n\n'}
                      {error.stack}
                    </>
                  )}
                </pre>
                <Button
                  icon={<CopyOutlined />}
                  type="ghost"
                  style={{ position: 'absolute', right: '5px', top: '5px' }}
                  onClick={() => {
                    navigator.clipboard.writeText(error.stack || '');
                    message.success(
                      "Détails de l'erreur copiés dans le presse-papiers"
                    );
                  }}
                />
              </div>
            )}

            <div style={{ marginTop: '1.5rem' }}>
              {customActions ? (
                customActions
              ) : (
                <Row gutter={[16, 16]} justify="center">
                  {showHomeButton && (
                    <Col>
                      <Button type="primary" onClick={handleGoHome}>
                        Retourner à l'accueil
                      </Button>
                    </Col>
                  )}
                  {showReloadButton && (
                    <Col>
                      <Button onClick={handleReload}>Recharger la page</Button>
                    </Col>
                  )}
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Col>

      {showFooter && <Footer />}
    </Row>
  );
}
